import { Col, Row } from 'antd';
import { Routes } from 'config/routes';
import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import RecruiterDashboardTabs from '../RecruiterDashboardTabs';

const RecruiterDashboard: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === Routes.DashboardsRecruiter) {
      navigate(Routes.DashboardsRecruiterDashboard, { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <Row gutter={[10, 10]} justify="space-between">
      <Col span={24}>
        <RecruiterDashboardTabs />
      </Col>
    </Row>
  );
};

export default RecruiterDashboard;
